import {InputTextV2} from '@prtimes-basis/input';
import {FormField, useFormField} from '../../../form-field';
import companyRegistrationPageStyles from '@/features/company-registration/styles.module.css';

export function EmailField() {
  return (
    <FormField.Root name='contactPersonInfo.email'>
      <Body />

      <FormField.Error />

      <FormField.Description>
        メールアドレスがログインIDになります
      </FormField.Description>
    </FormField.Root>
  );
}

function Body() {
  const {fieldProps} = useFormField({
    hasDescription: true,
  });

  return (
    <InputTextV2
      type='email'
      wrapperClassName={companyRegistrationPageStyles.sizedInput}
      {...fieldProps}
    />
  );
}
